import { Event } from "./dtos/event";
import { Respondent } from "./dtos/respondent";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:5001/api";

export const createEvent = async (event: Event): Promise<Event> => {
  try {
    const response = await axios.post(`${API_URL}/events`, event);
    return response.data;
  } catch (error) {
    console.error("Error creating event:", error);
    throw error;
  }
};

export const getEvent = async (id: string): Promise<Event> => {
  try {
    const response = await axios.get(`${API_URL}/events/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error getting event:", error);
    throw error;
  }
};

export const respondToEvent = async (
  id: string,
  respondent: Respondent
): Promise<Event> => {
  try {
    const response = await axios.post(`${API_URL}/events/${id}/respond`, {
      respondent,
    });
    return response.data;
  } catch (error) {
    console.error("Error responding to event:", error);
    throw error;
  }
};

export const uploadImage = async (image: File): Promise<{ imageId: string; filename: string }> => {
  try {
    const formData = new FormData();
    formData.append('file', image);

    const response = await axios.post(`${API_URL}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

export const updateEvent = async (id: string, event: Event, editKey: string): Promise<Event> => {
  try {
    const response = await axios.put(`${API_URL}/events/${id}`, {
      ...event,
      editKey,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating event:", error);
    throw error;
  }
};

export const checkEditKey = async (id: string, editKey: string): Promise<boolean> => {
  try {
    const response = await axios.get(`${API_URL}/events/${id}/edit-key`, {
      params: {
        editKey,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error checking edit key:", error);
    throw error;
  }
};


export default createEvent;
